import React, {useState, useEffect} from 'react'
import {
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  AppBar,
  Tab,
  Tabs,
  Table,
  InputLabel,
  Grid,
  FormControl,
  MenuItem,
  Select,
} from '@material-ui/core'

export default function DateTypeField({
  type,
  idx,
  onChange = (e, key, value, typeId) => {},
  list,
  data,
}) {
  const [additionalField, setAdditionalField] = useState(false)
  const [showBetweenField, setShowBetweenField] = useState(false)
  const [sameTypeList, setSameTypeList] = useState([])

  useEffect(() => {
    const filterdData = list.filter(data => type.type === data.type && type.name !== data.name)
    setSameTypeList(filterdData)
  }, [list, type])

  useEffect(() => {
    if (data?.compare_select_one === 'day_value') {
      setAdditionalField(true)
    }
    // eslint-disable-next-line
  }, [])

  let dateCalculationOptions = [
    {name: 'Plus', value: '+'},
    {name: 'Minus', value: '-'},
  ]

  return (
    <div>
      <Grid row xs={12}>
        <FormControl variant="outlined" style={{minWidth: '100px'}}>
          <InputLabel id="demo-simple-select-outlined-label">Is on</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            defaultValue={data?.date_compare}
            name="select1"
            onChange={e => {
              onChange(
                e,
                'list_filters_attributes',
                e.target.value,
                'date_compare',
                idx,
                '',
                type.id
              )
              if (e.target.value === '<>' || e.target.value === '><') {
                setShowBetweenField(true)
              } else {
                setShowBetweenField(false)
              }
            }}
            label="Is on"
          >
            <MenuItem value="=="> Is on </MenuItem>
            <MenuItem value="=<">Is on or before </MenuItem>
            <MenuItem value="<">Is before </MenuItem>
            <MenuItem value=">">Is after</MenuItem>
            <MenuItem value="=>">Is on or after </MenuItem>
            <MenuItem value="<>">Is between </MenuItem>
            <MenuItem value="><">Is not between</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" style={{minWidth: '145px'}}>
          <InputLabel id="demo-simple-select-outlined-label2">a specific date</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label2"
            id="demo-simple-select-outlined"
            defaultValue={data?.compare_select_one}
            name="select2"
            onChange={e => {
              onChange(
                e,
                'list_filters_attributes',
                e.target.value,
                'compare_select_one',
                idx,
                '',
                type.id
              )
              if (e.target.value === 'day_value') {
                setAdditionalField(true)
              } else {
                setAdditionalField(false)
              }
            }}
            label="a specific date"
          >
            <MenuItem value="specific_date">a specific date</MenuItem>
            <MenuItem value="day_value">value of</MenuItem>
          </Select>
        </FormControl>
        {additionalField && (
          <>
            {sameTypeList.length > 0 && (
              <FormControl variant="outlined" style={{minWidth: '100px'}}>
                <Select
                  defaultValue={data?.compare_select_one}
                  onChange={e => {
                    onChange(
                      e,
                      'list_filters_attributes',
                      e.target.value,
                      'compare_value_one',
                      idx,
                      '',
                      type.id
                    )
                  }}
                >
                  {sameTypeList.map((val, id) => {
                    return (
                      <MenuItem value={val.id} key={id}>
                        {val.name}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            )}
            <FormControl
              variant="outlined"
              className="ap-textfield"
              style={{width: 93, marginTop: 16}}
            >
              <InputLabel id=""></InputLabel>
              <Select
                labelId=""
                id=""
                defaultValue={`${data?.day_shift_two}`}
                // value={data.op}
                onChange={(e, value) =>
                  onChange(
                    e,
                    'list_filters_attributes',
                    e.target.value,
                    'day_shift_two',
                    idx,
                    '',
                    type.id
                  )
                }
                style={{width: '93px'}}
              >
                {dateCalculationOptions.map(opt => {
                  return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
                })}
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              id="standard-number"
              label="Days"
              type="number"
              defaultValue={data?.day_one}
              onChange={(e, value) =>
                onChange(e, 'list_filters_attributes', e.target.value, 'day_one', idx, '', type.id)
              }
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{min: 0}}
              className="ap-textfield"
              style={{width: 76, marginTop: 16}}
            />
            <TextField
              variant="outlined"
              id="standard-number"
              label="Months"
              type="number"
              inputProps={{min: 0}}
              defaultValue={data?.month_one}
              onChange={(e, value) =>
                onChange(
                  e,
                  'list_filters_attributes',
                  e.target.value,
                  'month_one',
                  idx,
                  '',
                  type.id
                )
              }
              InputLabelProps={{
                shrink: true,
              }}
              className="ap-textfield"
              style={{width: 76, marginTop: 16}}
            />
            <TextField
              variant="outlined"
              id="standard-number"
              label="Years"
              type="number"
              inputProps={{min: 0}}
              defaultValue={data?.year_one}
              onChange={(e, value) =>
                onChange(e, 'list_filters_attributes', e.target.value, 'year_one', idx, '', type.id)
              }
              InputLabelProps={{
                shrink: true,
              }}
              className="ap-textfield"
              style={{width: 76, marginTop: 16}}
            />
          </>
        )}
      </Grid>
      {additionalField === false && (
        <Grid xs={12} row>
          <FormControl>
            <TextField
              variant="outlined"
              className="ap-datefield"
              // label="Date"
              defaultValue={data?.date_one}
              id="date"
              type="Date"
              placeholder=""
              onChange={e => {
                onChange(e, 'list_filters_attributes', e.target.value, 'date_one', idx, '', type.id)
              }}
            />
          </FormControl>
        </Grid>
      )}
      {showBetweenField && (
        <Grid xs={12} row>
          <FormControl variant="outlined" style={{minWidth: '145px'}}>
            <InputLabel id="demo-simple-select-outlined-label2">a specific date</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label2"
              id="demo-simple-select-outlined"
              defaultValue={data?.compare_select_two}
              name="select2"
              onChange={e => {
                onChange(
                  e,
                  'list_filters_attributes',
                  e.target.value,
                  'compare_select_two',
                  idx,
                  '',
                  type.id
                )
                if (e.target.value === 'day_value') {
                  setAdditionalField(true)
                } else {
                  setAdditionalField(false)
                }
              }}
              label="a specific date"
            >
              <MenuItem value="specific_date">a specific date</MenuItem>
              <MenuItem value="day_value">value of</MenuItem>
            </Select>
          </FormControl>
          {additionalField === false && (
            <FormControl>
              <TextField
                variant="outlined"
                className="ap-datefield"
                // label="Date"
                id="date"
                type="Date"
                placeholder=""
                defaultValue={data?.date_two}
                onChange={e => {
                  onChange(
                    e,
                    'list_filters_attributes',
                    e.target.value,
                    'date_two',
                    idx,
                    '',
                    type.id
                  )
                }}
              />
            </FormControl>
          )}
        </Grid>
      )}
    </div>
  )
}
